<ul class="voucher-list">
  <li *ngFor="let voucher of coupons">
    <span class="cx-cart-coupon-code">{{ voucher }}</span>

    @if (!isReadOnly) {
      <button
        type="button"
        class="btn-remove"
        [attr.aria-label]="'common.close' | cxTranslate"
        (click)="removeVoucher(voucher)"
        [disabled]="cartIsLoading"
        [class.disabled]="cartIsLoading"
      >
        <span aria-hidden="true" class="icon material-symbols-outlined d-flex"> close </span>
      </button>
    }
  </li>
</ul>
